import { useState } from "react";
import { useSubscribeNewsletter } from "../../functions/newsletterHook";

const NewsletterSignup = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  const { mutate, isLoading } = useSubscribeNewsletter();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!name || !email) return;

    mutate(
      { name, email },
      {
        onSuccess: () => {
          setName(""); // Limpiar el campo de nombre
          setEmail(""); // Limpiar el campo de email
        },
      }
    );
  };

  return (
    <div className="bg-gray-50 rounded-lg p-4">
      <h4 className="font-semibold mb-2">Subscribe to Our Newsletter</h4>
      <p className="text-sm text-gray-600 mb-4">
        Get the latest updates directly in your inbox.
      </p>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Enter your name"
          className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-2"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
        <input
          type="email"
          placeholder="Enter your email"
          className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-2"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button
          type="submit"
          className="w-full bg-navy-900 text-white px-4 py-2 rounded-lg text-sm font-medium"
          disabled={isLoading}
        >
          {isLoading ? "Subscribing..." : "Subscribe"}
        </button>
      </form>
    </div>
  );
};

export default NewsletterSignup;
